export default "__VITE_ASSET__siB_cbD3__"